import { firestore, getDoc, doc } from '../../../src/utils/firestore'
import { skpApiSettings, oneilApiJWT, oneilApiAcntValidate } from '../common/appConstants'

export const validateAccountData = async(country, wmsInstance, wmsRegion, accntLvl1, accntLvl2, accntLvl3) => {
  try {
    const [jwtDetails] = await Promise.all([
      await getJwt(wmsInstance)
    ])

    const jwt = jwtDetails?.access_token

    const [result] = await Promise.all([
      await validateAccountApi(jwt, country, wmsInstance, wmsRegion, accntLvl1, accntLvl2, accntLvl3)
    ])

    if (accntLvl1 === result?.accountId || accntLvl2 === result?.divisionId || accntLvl3 === result?.departmentId) {
      return 'success'
    } else {
      return result
    }
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error.errors[0].message ? error.errors[0].message : 'unexpected error occurred' }
    }
  }
}

export const getJwt = async(wmsInstance) => {
  try {
    const apiDoc = await getDoc(doc(firestore, skpApiSettings, oneilApiJWT))
    const apiDocData = apiDoc.data()
    const base64Credentials = btoa(`${apiDocData?.header?.clientId}:${apiDocData?.header?.clientSecret}`)
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', apiDocData?.header?.contentType)
    myHeaders.append('Authorization', `Basic ${base64Credentials}`)

    const urlencoded = new URLSearchParams()
    urlencoded.append('username', apiDocData?.body?.username)
    urlencoded.append('password', apiDocData?.body?.password)
    urlencoded.append('grant_type', apiDocData?.body?.grant_type)

    const requestOptions = {
      method: apiDocData?.method,
      headers: myHeaders,
      body: urlencoded,
      redirect: apiDocData?.redirect
    }

    const [result] = await Promise.all([
      fetch(apiDocData?.endpoint, requestOptions)
    ])

    const jwtData = await result.json()
    return jwtData
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error.errors[0].message ? error.errors[0].message : 'unexpected error occurred' }
    }
  }
}

export const validateAccountApi = async(jwt, country, wmsInstance, wmsRegion, accntLvl1, accntLvl2, accntLvl3) => {
  try {
    const apiDoc = await getDoc(doc(firestore, skpApiSettings, oneilApiAcntValidate))
    const apiDocData = apiDoc.data()
    const myHeaders = new Headers()
    myHeaders.append('accept', apiDocData?.header?.accept)
    myHeaders.append('userid', apiDocData?.header?.userid)
    myHeaders.append('Authorization', `Bearer ${jwt}`)
    myHeaders.append('region', country)
    myHeaders.append('wmsCode', wmsInstance)
    myHeaders.append('recordCenter', wmsRegion)

    const requestOptions = {
      method: apiDocData?.method,
      headers: myHeaders,
      redirect: apiDocData?.redirect
    }

    let url = `${apiDocData?.endpoint}/${encodeURIComponent(accntLvl1)}`
    if (accntLvl2) { url = `${url}/division/${encodeURIComponent(accntLvl2)}` }
    if (accntLvl2 && accntLvl3) { url = `${url}/department/${encodeURIComponent(accntLvl3)}` }
    let isError = false
    const [result] = await Promise.all([
      fetch(url, requestOptions)
        .then(response => {
          return response
        })
        .catch(error => {
          isError = true
          return error
        })
    ])

    if (!isError) {
      const response = await result.json()
      return response
    } else {
      return result.message
    }
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error.errors[0].message ? error.errors[0].message : 'unexpected error occurred' }
    }
  }
}